import { onBoot /* , addListener */ } from 'rtk'
import { locationChange } from './actions'
import { history } from './constants'

onBoot(({ payload }, { dispatch, getState }) => {
    history.listen(({ location, action }) =>
        dispatch(locationChange({ location, action }))
    )
})
// addListener(action, ({ payload }, { dispatch, getState })=>{});
